import { Box, BoxProps, Text } from "shared/components/Spor";
import { useThemeSemantic } from "shared/theme/themeSemantic";
import { Semantics } from "shared/utils/semantics";
import styled, { useTheme } from "styled-components";

const StyledBox = styled(Box)`
  position: relative;
  border-radius: 5px;
  height: 18px;
  min-width: 18px;
  z-index: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const _ALERT_SEMANTICS = [
  "warning",
  "success",
  "alarm",
  "transparent",
  "transparentInverted",
] as const satisfies ReadonlyArray<Semantics>;

type AlertsCounterSemantics = (typeof _ALERT_SEMANTICS)[number];

export const AlertsCounter = ({
  alerts,
  semantics,
  // Default to hiding the counter when there are no alerts
  displayWhenZero = false,
  ...rest
}: {
  alerts: number;
  semantics: AlertsCounterSemantics;
  displayWhenZero?: boolean;
} & BoxProps) => {
  const semanticTheme = useThemeSemantic(semantics);
  const theme = useTheme();

  let borderColor = "transparent";
  switch (semantics) {
    case "transparent":
      borderColor = theme.colorOutlineMain;
      break;
    case "transparentInverted":
      borderColor = semanticTheme.colorOutlineInverted;
      break;
    case "warning":
    case "success":
    case "alarm":
      break;
  }

  let backgroundColor = semanticTheme.colorSemantic;
  switch (semantics) {
    case "warning":
      backgroundColor = theme.colorAlertsCounterWarningBackground;
      break;
    case "success":
      backgroundColor = theme.colorAlertsCounterSuccessBackground;
      break;
    case "alarm":
      backgroundColor = theme.colorAlarmPulse;
      break;
    case "transparent":
    case "transparentInverted":
      break;
  }

  let textColor = theme.colorAlertsCounterTextOnColor;
  switch (semantics) {
    case "transparent":
      textColor = theme.colorTextMain;
      break;
    case "transparentInverted":
      textColor = theme.colorTextInverted;
      break;
    case "warning":
      textColor = theme.colorAlertsCounterWarningText;
      break;
    case "success":
    case "alarm":
      break;
  }

  if (alerts === 0 && !displayWhenZero) return null;

  return (
    <StyledBox
      backgroundColor={backgroundColor}
      border={`1px solid ${borderColor}`}
      {...rest}
    >
      <Text
        color={textColor}
        variant="xs"
        fontWeight="600"
        textAlign="center"
        paddingInline="3px"
        style={{ fontSize: "12px", lineHeight: 0 }}
      >
        {alerts}
      </Text>
    </StyledBox>
  );
};
